module.exports = __webpack_public_path__ + "static/media/img_Inscription_syuku@3x.af736673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Inscription_syuku@3x.png
// module id = 979
// module chunks = 0